export default "__VITE_ASSET__337f7bb5__"